class ProductsShowcase extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.ps-slide'));
    this.tabs = Array.from(this.querySelectorAll('.ps-tab'));
    this.currentIndex = 0;

    this.querySelectorAll('.ps-tab').forEach((tab) => {
      tab.addEventListener('click', () => this.goTo(parseInt(tab.dataset.index, 10)));
    });

    this.querySelectorAll('.ps-arrow--prev').forEach((btn) => {
      btn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    });

    this.querySelectorAll('.ps-arrow--next').forEach((btn) => {
      btn.addEventListener('click', () => this.goTo(this.currentIndex + 1));
    });

    this.syncPanelPadding();

    this._resizeObserver = new ResizeObserver(() => this.syncPanelPadding());
    this._resizeObserver.observe(this);
  }

  disconnectedCallback() {
    if (this._resizeObserver) this._resizeObserver.disconnect();
  }

  goTo(index) {
    const count = this.slides.length;
    if (!count) return;

    const next = ((index % count) + count) % count;

    this.slides[this.currentIndex].classList.remove('ps-slide--active');
    this.currentIndex = next;
    this.slides[this.currentIndex].classList.add('ps-slide--active');

    this.syncPanelPadding();
  }

  syncPanelPadding() {
    const slide = this.slides[this.currentIndex];
    if (!slide) return;

    const products = slide.querySelector('.ps-products');
    const textPanel = slide.querySelector('.ps-content__text');
    const mediaPanel = slide.querySelector('.ps-content__media');
    if (!products || !textPanel) return;

    const isDesktop = getComputedStyle(products).position === 'absolute';

    if (!isDesktop) {
      this.slides.forEach((s) => {
        const tp = s.querySelector('.ps-content__text');
        const mp = s.querySelector('.ps-content__media');
        if (tp) tp.style.paddingBottom = '';
        if (mp) mp.style.paddingBottom = '';
      });
      return;
    }

    const h = products.offsetHeight;
    if (!h) return;

    textPanel.style.paddingBottom = h + 'px';
    if (mediaPanel) mediaPanel.style.paddingBottom = h + 'px';
  }
}

customElements.define('products-showcase', ProductsShowcase);
